import apiConnection from '$app/plugins/api-connection'
import { startAuthSession, endAuthSession } from '$app/auth/auth-session.js'
import getConfigs from '$app/configs'

const storedUser = { ...JSON.parse(localStorage.getItem('vpk-user')) };
let sessionTimeout = 5;
getConfigs().then(configs => { sessionTimeout = configs.sessionTimeout; });

const storeUser = (ste) => {
  const { name, expires, roles } = ste;
  localStorage.setItem('vpk-user', JSON.stringify({ name, expires, roles }));
}

// STATE
const state = {
  name: storedUser.name,
  expires: storedUser.expires,
  roles: storedUser.roles || [],
  reauth: false,
  afterLogin: null
}

// MUTATIONS
const mutations = {
  extendSession(state) {
    const now = new Date();
    if (state.expires && state.expires > now) {
      state.expires = now.setMinutes(now.getMinutes() + sessionTimeout);
      storeUser(state);
    }
  },
  setUser(state, user) {
    const now = new Date();
    state.name = user.name;
    state.expires = now.setMinutes(now.getMinutes() + sessionTimeout);
    state.roles = user.roles;
    storeUser(state);
  },
  logout(state) {
    state.name = null;
    state.expires = null;
    state.roles = [];
    localStorage.removeItem('vpk-user');
  },
  reauth(state) {
    state.reauth = true;
    state.name = null;
    state.expires = null;
    state.roles = [];
    localStorage.removeItem('vpk-user');
  },
  setAfterLogin(state, to) {
    state.afterLogin = { ...to }
  }
}

// ACTIONS
const actions = ({
  setUser({ commit }, user) {
    commit('setUser', user);
    commit('extendSession');
    startAuthSession();
  },
  logout({ commit }, hardLogout) {
    endAuthSession();
    commit('logout');
    apiConnection.get('account/logout?hardLogout=' + hardLogout);
  },
  checkAuth({ getters, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      if (getters.isAuthenticated()) {
        commit('extendSession');
        window.clearTimeout(window.inactivityTimer);
        window.inactivityTimer = window.setTimeout(function () {
          dispatch('logout');
        }, sessionTimeout * 60000);
        resolve(true);
      } else {
        resolve(false)
      }
    });
  }
})

// GETTERS
const getters = {
  isAuthenticated: (state) => () => {
    return state.expires != null && state.expires > new Date();
  },
  hasRole: (state, getters) => {
    return (chkRoles) => {
      if (typeof chkRoles === 'string') {
        chkRoles = chkRoles.split(',').map(function (e) { return e.trim() });
      }
      if (!Array.isArray(chkRoles)) {
        return false;
      }
      if (getters.isAuthenticated()) {
        return !!chkRoles.find(r1 => {
          return state.roles.some(r2 => { return r1 === r2 })
        });
      } else return false;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
